import React, { useEffect } from 'react'

import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const InvestDollars = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
                This enables Bonpellz users invest in dollars on our platform


          </h3>
          <BodyText>
                 Here is an opportunity to build up your wealth in the USD dollars.

          </BodyText>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8613 (1).svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}